import produce from 'immer';
import { ReducerActionRotaSP } from 'store/modules/types';
import { toSelect } from 'utils/genericFunctions';
import { Types, ConsultarNaturalidades } from './types';

export const INITIAL_STATE: ConsultarNaturalidades = {
	status: 0,
	data: null,
	enum: [],
	totalRegistrosConsulta: 0,
	instanceRequest: undefined,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ConsultarNaturalidades {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_NATURALIDADES_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.enum = INITIAL_STATE.enum;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				draft.instanceRequest = action.instanceRequest;
				break;
			}

			case Types.CONSULTAR_NATURALIDADES_SUCCESS: {
				draft.enum = toSelect(action.payload.data, 'descricao', 'id');
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				draft.totalRegistrosConsulta =
					action.payload.headers['total-num-registros'];
				break;
			}

			case Types.CONSULTAR_NATURALIDADES_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CONSULTAR_NATURALIDADES_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.enum = INITIAL_STATE.enum;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				draft.instanceRequest = INITIAL_STATE.instanceRequest;
				break;
			}

			default:
		}
		return draft;
	});
}
